/* eslint-disable @typescript-eslint/no-unused-vars */
import { Paper, Typography, Stack } from '@mui/material';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import { now } from '@weft/utils';
import { VyTableToolbar } from 'apps/app/src/components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { formatDate } from 'apps/app/src/utils/date';
import { ReportMenu } from '../reports-page/reports-page-components/ReportMenu';
import { getReportJobType } from '../reports-page/reports-page-components/ReportsPageContent';
import type { ReportType } from '../reports-page/reports-page-types/report-type';

type ReportTableProps = {
  title: string;
  placeholder: string;
  exportCsvFileName: string;
  reportType: ReportType;
  children: React.ReactNode;
  onSearch: (searchValue: string) => void;
  apiRef: React.MutableRefObject<GridApiCommunity>
};

export const ReportTable: React.FC<ReportTableProps> = ({
  title,
  placeholder,
  exportCsvFileName,
  reportType,
  children,
  onSearch,
  apiRef,
}) => {
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({ fileName: `${exportCsvFileName} ${formatDate(now())}` });
  };

  return (
    <Paper
      variant="outlined"
      sx={theme => ({
        borderRadius: '12px',
        top: '20px',
        boxShadow: theme.shadows[1],
        height: '90%',
        overflow: 'hidden',
        position: 'relative',
      })}
    >
      <VyTableToolbar>
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
        >
          <Typography
            variant="h6"
            fontWeight={500}
            fontSize="20px"
          >
            {title}
          </Typography>
        </Stack>
        <VyTableToolbar.Actions>
          <VyTableToolbar.SearchInput
            showLabel={false}
            onChange={(event) => onSearch(event.target.value)}
            defaultValue=''
            placeholder={placeholder}
          />
          
          <ReportMenu 
            reportType={reportType} 
            selectedReportJob={getReportJobType(reportType)}
            onExportCsv={handleExport}
            shouldRequestReport={false}
            shouldExportAsCsv
          /> 
        </VyTableToolbar.Actions>
      </VyTableToolbar>

      {children}
    </Paper>
  );
};